import { render } from "./TalkToUsHero.vue?vue&type=template&id=6580c168"
import script from "./TalkToUsHero.vue?vue&type=script&lang=js"
export * from "./TalkToUsHero.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__